import { AddStaticText } from "../utils/AddStaticText";
import { AddStdIntEdit } from "../utils/AddStdIntEdit";
import { AddStdTextEdit } from "../utils/AddStdTextEdit";
import { appstr } from "../utils/appstr";
import {
  enumKeyboardTargetEnterAction,
  enumPanelBorderStyle,
  enumShortCutModKeys,
  kEnterOKShortCut,
  kSIHeight,
  kStdTEHeight
} from "../constants";
import { QPanel } from "./QPanel";
import { AddStdButtonAutoPos } from "../utils/AddStdButtonAutoPos";

export class QInputSpacingDialog extends QPanel {
  constructor() {
    super();
    this.fSpacing = null;
    this.fStartValue = null;
    this.fWSMgr = null;
    this.fWhichSpacing = null;

    this.fSrcControl = null;
    this.fSrcPanel = null;
  }

  InitSpacingDialog(
    wsMgr,
    srcControl,
    parentPanel,
    theWidth,
    startValue,
    whichSpacing //, srcElement)
  ) {
    this.fStartValue = startValue;
    this.fWhichSpacing = whichSpacing;

    //   if (srcElement)
    //       srcElement = srcElement["parent"];
    this.fSrcControl = srcControl;
    this.fSrcPanel = parentPanel;

    this.fWSMgr = wsMgr;
    this.SizePanel(theWidth, kSIHeight);
    this.SetModalOn(true);
    this.SetFillColor(this.fUIColors.GetPrimaryPanelFillColor());
    this.SetShadowOn(true);
    this.SetBorderStyle(enumPanelBorderStyle.singleBorder);

    this.fTextColor = this.fUIColors.GetHeaderTextColor();
    var indent = 10;
    var teWidth = theWidth - 2 * indent;
    var yPos = 6;

    var s = appstr("enterval") + ":";
    AddStaticText(this, indent, yPos, s, false, this.fTextColor);
    yPos += 20;

    //this.fSpacing = AddStdTextEdit(this, indent, yPos, teWidth, kStdTEHeight, null, 44, 0, true);
    this.fSpacing = AddStdIntEdit(this, indent, yPos, teWidth, kStdTEHeight, null, 3, 0, true);
    this.fSpacing.SetEditContent(startValue);

    yPos = kSIHeight - 30;
    var buttonHeight = 20;
    var buttonMargin = indent;
    var butWidth = 50;

    var xRight = theWidth - buttonMargin;
    var okBut = AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("OK"),
      null,
      null,
      false,
      "OKSD"
    );
    okBut.SetCmdShortCut(kEnterOKShortCut, enumShortCutModKeys.none, "");

    xRight = okBut.GetPositionX() - buttonMargin;
    AddStdButtonAutoPos(
      this,
      null,
      xRight,
      "right",
      butWidth,
      yPos,
      buttonHeight,
      appstr("Cancel"),
      null,
      null,
      false,
      "CancelSD"
    );

    var helpButton = this.AddHelpButton("enterspacing_help", true);
    helpButton.AutoPosition();
  }

  BecomeKeyboardTarget() {
    var wsMgr = this.fWSMgr;
    wsMgr.SetKeyboardTarget(this.fSpacing, this, enumKeyboardTargetEnterAction.selectAll);
  }

  GetNewSpacing(aCmd) {
    var newValue = this.fSpacing.GetRealContent();
    if (newValue.length == 0) newValue = "0";

    newValue = parseInt(newValue);

    return newValue;
  }

  ExecuteCommand(aCmd) {
    var cmdCode = aCmd.GetCmdCode();
    var wsMgr = aCmd.GetWSMgr();
    var panelHandled = false;

    switch (cmdCode) {
      case "OKSD":
        var newValue = this.GetNewSpacing();
        var s = this.fWhichSpacing + "_sync";
        this.fSrcControl.SetValue(newValue);
        aCmd.ChangeCmdCode(s);
        wsMgr.RemovePanel(this);
        if (this.fSrcPanel) this.fSrcPanel.ExecuteCommand(aCmd);
        panelHandled = true;
        break;
      case "CancelSD":
      case "CNCL":
        panelHandled = true;
        wsMgr.RemovePanel(this);
        break;
    }

    return panelHandled;
  }
}
